import React from "react";
import MarkersEditorShared from "./MarkersEditorShared";
import { api } from "../lib/api";

export default function VideoMarkersEditor({
  video,
  routes = [],
  editingRoute = {},
  editingPlaylist = {},
  onClose,
  onSaved,
  isAdmin = false,
}) {
  const handleSave = async (payload) => {
    if (!video?.id) return;
    if (isAdmin) {
      await api.put(`/admin/videos/${video.id}`, payload);
    } else {
      await api.put(`/me/videos/${video.id}`, payload);
    }
  };

  return (
    <MarkersEditorShared
      video={video}
      routes={routes}
      editingRoute={editingRoute}
      editingPlaylist={editingPlaylist}
      onClose={onClose}
      onSaved={onSaved}
      onSave={handleSave}
    />
  );
}
